import copy from 'copy-to-clipboard';

function fallbackCopyText(text) {
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', 'readonly');
  input.style.position = 'fixed';
  input.style.left = '-9999px';
  input.style.top = '0';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.focus();
  input.select();
  input.setSelectionRange(0, input.value.length);

  try {
    if (document.execCommand && document.execCommand('copy')) {
      return true;
    }
  } catch (error) {
    // Continue with copy-to-clipboard fallback below.
  } finally {
    if (input.parentNode) input.parentNode.removeChild(input);
  }

  return copy(text, { format: 'text/plain' });
}

export async function copyText(text) {
  const value = String(text || '');
  if (!value) return false;

  if (copy(value, { format: 'text/plain' })) {
    return true;
  }

  if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (error) {
      // Mobile WebView may expose navigator.clipboard but reject the call.
    }
  }

  return fallbackCopyText(value);
}
